import axJava from './axJava'
import axParam from './axParam'

// 公众号随机码
export function GetRandomCode(data = {}) {
  return axJava({
    url: "/api/OfficialAccount/getRandomCode",
    method: "post",
    data
  });
}

// 发送请求
export function SendRequest(url, data = {}) {
  return axParam({
    url: url,
    method: "post",
    data: data,
  });
}
